export default "__VITE_ASSET__CmLj4L2F__"